import { Sparkles } from 'lucide-react';
import { type RecipeData, categoryLabels } from '@/data/mockData';
import { Clock, ArrowRight } from 'lucide-react';

interface TodayRecommendationCardProps {
  title: string;
  subtitle: string;
  recipes: RecipeData[];
  onSelect: (id: string) => void;
}

const TodayRecommendationCard = ({ title, subtitle, recipes, onSelect }: TodayRecommendationCardProps) => {
  if (recipes.length === 0) return null;

  // Show max 2 recipes on mobile to save space
  const display = recipes.slice(0, 2);

  return (
    <div className="gradient-primary rounded-xl p-3 text-primary-foreground relative overflow-hidden">
      <div className="absolute -bottom-4 -right-4 w-14 h-14 bg-white/10 rounded-full pointer-events-none" />
      <div className="relative z-10">
        <div className="flex items-center gap-1.5 mb-0.5">
          <Sparkles className="h-3 w-3" />
          <h3 className="text-[11px] font-semibold">{title}</h3>
        </div>
        <p className="text-[10px] text-primary-foreground/70 mb-2">{subtitle}</p>
        <div className="space-y-1">
          {display.map(r => (
            <button
              key={r.id}
              onClick={() => onSelect(r.id)}
              className="w-full flex items-center gap-2 bg-white/15 rounded-lg p-2 text-left hover:bg-white/25 transition-colors"
            >
              <div className="flex-1 min-w-0">
                <p className="text-[11px] font-medium truncate">{r.title}</p>
                <p className="text-[9px] text-primary-foreground/60 flex items-center gap-1 mt-0.5">
                  <span>{categoryLabels[r.category]}</span>
                  <span>•</span>
                  <span className="flex items-center gap-0.5"><Clock className="h-2 w-2" />{r.prepTime}</span>
                </p>
              </div>
              <ArrowRight className="h-3 w-3 flex-shrink-0 text-primary-foreground/50" />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TodayRecommendationCard;
